import BACKOFFICE_BASE_API_V1 from "./backofficeApi";

const ensureOk = async (response, fallbackMessage) => {
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || fallbackMessage);
  }
  return response.json();
};

export async function getArticles() {
  const response = await fetch(`${BACKOFFICE_BASE_API_V1}/articles`);
  return ensureOk(response, "Неуспешно вчитување на статии.");
}

export async function getArticleBySlug(slug) {
  const response = await fetch(`${BACKOFFICE_BASE_API_V1}/articles/${slug}`);
  return ensureOk(response, "Неуспешно вчитување на статија.");
}
